import { Buffer } from 'buffer';
import { consoleLogger } from '../config/di/container';

export const PROGRAMMATIC_CONVERSION_IMG_SRC: string = !!process.env
  .REACT_APP_PROGRAMMATIC_CONVERSION_IMG_SRC_AS_BASE64
  ? Buffer.from(
      process.env.REACT_APP_PROGRAMMATIC_CONVERSION_IMG_SRC_AS_BASE64!,
      'base64'
    ).toString()
  : '';
export const PROGRAMMATIC_CONVERSION_SCRIPT_SRC: string = !!process.env
  .REACT_APP_PROGRAMMATIC_CONVERSION_SCRIPT_SRC_AS_BASE64
  ? Buffer.from(
      process.env.REACT_APP_PROGRAMMATIC_CONVERSION_SCRIPT_SRC_AS_BASE64!,
      'base64'
    ).toString()
  : '';
export const PROGRAMMATIC_RETARGETING_IMG_SRC: string = !!process.env
  .REACT_APP_PROGRAMMATIC_RETARGETING_IMG_SRC_AS_BASE64
  ? Buffer.from(
      process.env.REACT_APP_PROGRAMMATIC_RETARGETING_IMG_SRC_AS_BASE64!,
      'base64'
    ).toString()
  : '';

export const isProgrammaticRetargetingLoaded = (): boolean => {
  return !!document.querySelector('img#programmatic-retargeting-pixel');
};

/**
 * Loads programmatic retargeting pixel img into the current DOM.
 * Returns a promise which resolves to {@code true} if the script needs to be initialized after.
 */
export function loadProgrammaticRetargetingPixel(
  programmaticRetargetingImgSrc?: string
): Promise<boolean> {
  if (!programmaticRetargetingImgSrc) {
    // don't try to load it if no programmaticRetargetingImgSrc got provided
    consoleLogger.error('Failed to load pixel', {
      pixel: 'programmatic_retargeting',
      reason: 'No image source provided!'
    });
    return Promise.resolve(false);
  }

  if (isProgrammaticRetargetingLoaded()) {
    consoleLogger.debug('⚙️ Programmatic retargeting script is already attached to DOM');
    return Promise.resolve(false);
  }

  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.width = 1;
    img.height = 1;
    img.id = 'programmatic-retargeting-pixel';
    img.src = 'data:,';
    img.setAttribute('data-cookieblock-src', programmaticRetargetingImgSrc);
    img.setAttribute('data-cookieconsent', 'marketing');
    img.alt = 'programmatic retargeting pixel';
    img.onerror = function () {
      reject('failed to load programmatic retargeting pixel');
    };
    document.head.appendChild(img);
    resolve(true);
  });
}

/**
 * Init programmatic retargeting pixel script.
 * Returns a promise which resolves to {@code true} if programmatic retargeting pixel is ready to use.
 */
export function initProgrammaticRetargetingPixel(
  initNeeded: boolean,
  programmaticRetargetingImgSrc?: string
): Promise<boolean> {
  if (!PROGRAMMATIC_RETARGETING_IMG_SRC) {
    consoleLogger.info(
      '⚠️ PROGRAMMATIC_RETARGETING_IMG_SRC is not set. initProgrammaticRetargetingPixel was triggered'
    );
  }

  // Nothing to do right now.
  return Promise.resolve(true);
}
